module.exports = __webpack_public_path__ + "img/sacco.e4b6dc4b.png";